// extracted by mini-css-extract-plugin
export default {"root":"Caption_root__noE7e"};